export default __webpack_public_path__ + "static/media/freshArrivals.6be0bfee.jpg";